import { Box, styled } from '@mui/system';

// -- Layout --
export const PanelContentContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}));

export const PanelHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 28px',
}));

export const PanelHeaderTitle = styled(Box)(() => ({
  fontSize: '16px',
  fontWeight: 500,
  color: '#303c42',
}));

export const PanelCloseButton = styled('button')(() => ({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '4px',
}));

export const PanelScrollArea = styled(Box)(() => ({
  flex: 1,
  overflowY: 'auto',
  padding: '0 16px 16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '11px',
}));

// -- Sections --
export const SectionCard = styled(Box)(() => ({
  backgroundColor: 'white',
  borderRadius: '8px',
  boxShadow: '2px 2px 10px 0px rgba(48,60,66,0.08)',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));

export const SectionTitle = styled(Box)(() => ({
  fontSize: '18px',
  fontWeight: 500,
  color: '#303c42',
}));

export const SectionDivider = styled(Box)(() => ({
  borderBottom: '1px solid #e7e8e8',
}));

export const SubSectionTitle = styled(Box)(() => ({
  fontWeight: 700,
  fontSize: '16px',
  color: '#303c42',
}));

export const ColumnTitleRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
}));

export const BreakTitle = styled(Box)(() => ({
  fontWeight: 700,
  fontSize: '14px',
  color: '#303c42',
}));

// -- Time columns --
export const TimeColumnContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '200px',
}));

export const TimeFieldsRow = styled(Box)(() => ({
  display: 'flex',
  gap: '8px',
}));

export const TimeFieldWrapper = styled(Box)(() => ({
  width: '96px',
}));

export const TimeFieldWrapperSmall = styled(Box)(() => ({
  width: '91px',
}));

export const BreakDivider = styled(Box)(() => ({
  borderBottom: '1px solid #e7e8e8',
  width: '190px',
  marginTop: '16px',
}));

export const EmptyStateText = styled(Box)(() => ({
  color: '#9ea2a2',
  fontSize: '14px',
}));

// -- General section --
export const GeneralFieldsRow = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
}));

export const WorkingTimesHeaderRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const ThreeColumnLayout = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '16px',
}));

// -- To be confirmed --
export const BreakHeaderRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '190px',
}));

export const LinkButton = styled('button')(() => ({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  textDecoration: 'underline',
  fontSize: '14px',
  color: '#303c42',
  fontFamily: "'Montserrat', sans-serif",
}));

export const AddBreakContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '12px',
}));

// -- Absence / Cost declaration --
export const AbsenceCostRow = styled(Box)(() => ({
  display: 'flex',
  gap: '24px',
  alignItems: 'flex-start',
}));

export const AbsenceCostFieldWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '200px',
}));

export const AbsenceCostColumnWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  flex: 1,
}));

export const CostDeclarationDataRow = styled(Box)(() => ({
  display: 'flex',
  gap: '8px',
  alignItems: 'flex-end',
}));

export const CostDeclarationTypeWrapper = styled(Box)(() => ({
  flex: 2,
}));

export const CostDeclarationValueWrapper = styled(Box)(() => ({
  flex: 1,
}));

export const CostDeclarationDeleteButton = styled('button')(() => ({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '4px',
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  marginBottom: '8px',
}));

// -- Audit --
export const AuditRow = styled(Box)(() => ({
  display: 'flex',
  gap: '24px',
}));

export const AuditFieldWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '200px',
}));

export const AuditValue = styled(Box)(() => ({
  fontSize: '16px',
  color: '#5f6161',
}));

export const AuditInlineField = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}));

export const StatusPill = styled(Box)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  padding: '7px 12px',
  borderRadius: '6px',
  fontSize: '14px',
  fontWeight: 600,
}));

export const StatusRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  maxWidth: '320px',
}));

export const AccuracyWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: '0px',
}));

export const AccuracyLabel = styled(Box)(() => ({
  fontSize: '13px',
  lineHeight: 1.2,
  color: '#5f6161',
}));

export const AccuracyText = styled(Box)(() => ({
  fontSize: '13px',
  fontWeight: 700,
  lineHeight: 1.2,
  color: '#5f6161',
}));

// -- Footer --
export const FooterContainer = styled(Box)(() => ({
  position: 'sticky',
  bottom: 0,
  backgroundColor: 'white',
  boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.05)',
  padding: '18px 24px',
  display: 'flex',
  justifyContent: 'center',
  gap: '16px',
  zIndex: 1,
}));

// -- Registered orange border --
export const OrangeBorderWrapper = styled(Box)(() => ({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#ff981f !important',
    borderWidth: '2px !important',
  },
}));
